import httpService from "./httpService";
import utils from "./utils";

export default {

  findAllReceived(form, pageable) {
    let params = utils.merge(form, pageable);
    return httpService.get("/tkTaskView/taskReceived", {params: params});
  },

  findAllCoordinated(form, pageable) {
    let params = utils.merge(form, pageable);
    return httpService.get("/tkTaskView/taskCoordinated", {params: params});
  },

  countAssigned(usingAdvanceSearch, keyword, taskStatuses, form) {
    let params = utils.merge(
      {
        usingAdvanceSearch: usingAdvanceSearch,
        keyword: keyword,
        taskStatuses: taskStatuses
      },
      form
    );

    return httpService.get("/tkTaskView/taskAssigned/count", {
      params: params
    });
  },

  findAllAssigned(searchForm, pageable) {
    let params = utils.merge(searchForm, pageable);
    return httpService.get("/tkTaskView/taskAssigned", {params: params});
  },

  findAllTasksInDept(form, pageable) {
    let params = utils.merge(form, pageable);
    return httpService.get("/tkTaskView/findAllTasksInDept", {params: params});
  },

  baoCaoTongHopThang(form) {
    return httpService.get("/tkTaskView/baoCaoTongHopThang", {params: form});
  },
};



// WEBPACK FOOTER //
// ./src/services/tkTaskViewService.js